import type { ReactNode } from 'react';

import { getTestProps } from '../../../lib/helpers';

interface TypeCardRowProps {
  /**
   * Type card row title
   */
  title?: string;
  /**
   * Type card row value
   */
  value?: string | number | boolean;
  /**
   * Type card row icon
   */
  icon?: ReactNode;
  /**
   * Type card row test id
   */
  testId?: string;
}

const TypeCardRow = ({
  title = '',
  icon,
  value = '',
  testId = '',
}: TypeCardRowProps) => {
  if (!title && !value) return false;

  return (
    <div
      className="flex items-center py-1.5
      text-slate-900 dark:text-white"
      {...getTestProps(testId, 'container')}
    >
      {icon}
      {value && (
        <span className="font-bold mr-1" {...getTestProps(testId, 'value')}>
          {value}
        </span>
      )}
      {title && <span {...getTestProps(testId, 'title')}>{title}</span>}
    </div>
  );
};

export default TypeCardRow;
